import { Injectable } from '@angular/core';
import {EmailServerConfig} from '../data/emailServerConfig';
import {EmailObject} from '../data/email';
import {QueryDTO, QueryModel} from '../../query/data/queryCreator';
import {EmailQuery} from '../data/emailQuery';
import {AppService} from '../../app-common/services/app/app.service';
import {ElectronService} from 'ngx-electron';

@Injectable({
  providedIn: 'root'
})
export class EmailingServiceService {
  emails: EmailObject[] = [];

  constructor( private appService: AppService,
               private electronService: ElectronService) {
    if(this.electronService.isElectronApp) {
      this.electronService.ipcRenderer.on('getEmails', (event, data) => {
        const fetchedEmails: any[] = data;

        this.emails = [];
        for (let i = 0; i < fetchedEmails.length; i++) {
          const tmp: EmailObject = fetchedEmails[i];

          this.emails.push(tmp);
        }
      });
    }
  }

  async sendMail(email: EmailObject) {
    const obj = {
      from: email.sender,
      to: email.receiver,
      subject: email.subject,
      body: email.content,
      date: email.date,
      cc: email.cc,
      bcc: email.bcc,
      attachments: email.attachments
    };
    return await this.electronService.ipcRenderer.invoke('send', obj);
  }

  async fetchSMTPConfig() {
    const result = await this.electronService.ipcRenderer.invoke('askSMTPConfig');
    return result;
  }

  async fetchIMAPConfig() {
    const result = await this.electronService.ipcRenderer.invoke('askIMAPConfig');
    return result;
  }

  async fetchPOP3Config() {
    const result = await this.electronService.ipcRenderer.invoke('askPOP3Config');
    return result;
  }

  async saveSMTPConfig(config: EmailServerConfig) {
    const result = await this.electronService.ipcRenderer.invoke('saveSMTP', config);

    if(result === 'Ok')
      this.appService.showSuccessMessage("SMTP configuration saved!");
  }

  async saveIMAPConfig(config: EmailServerConfig) {
    const result = await this.electronService.ipcRenderer.invoke('saveIMAP', config);

    if(result === 'Ok')
      this.appService.showSuccessMessage("IMAP configuration saved!");
  }

  async savePOP3Config(config: EmailServerConfig) {
    const result = await this.electronService.ipcRenderer.invoke('savePOP3', config);

    if(result === 'Ok')
      this.appService.showSuccessMessage("POP3 configuration saved!");
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  async loadEmails(query: EmailQuery) {
    this.electronService.ipcRenderer.send('askEmailsFromFolder', query);
    await this.delay(500);
    return this.emails;
  }

  async getEmailAttachments(folder: string, emailId: number) {
    let filePaths: string[] = [];
    filePaths = await this.electronService.ipcRenderer.invoke('getAttachments', {folderName: folder, id: emailId});
    return filePaths;
  }

  syncFolder(folderPath: string) {
    this.electronService.ipcRenderer.send('syncFolder', folderPath);
  }

  markSeen(emailUID) {
    this.electronService.ipcRenderer.invoke('markSeen', emailUID);
  }

  markUnseen(emailUID) {
    this.electronService.ipcRenderer.invoke('markUnseen', emailUID);
  }

  async openFileSelector() {
    let filePaths: string[] = [];
    filePaths = await this.electronService.ipcRenderer.invoke('email-upload-file-selector');
    return filePaths;
  }
}
